export function buildSubscriptionOrderFilters(input: {
  search: string;
  paymentStatus: string;
  subscriptionStatus: string;
  userType: string;
  orderKind?: string;
  fulfillmentStatus?: string;
  autoRenewStatus?: string;
  alignmentStatus?: string;
  membershipView?: string;
  abnormalOnly: boolean;
}) {
  const params: Record<string, string | boolean> = {};
  if (input.search.trim()) params.keyword = input.search.trim();
  if (input.paymentStatus) params.payment_status = input.paymentStatus;
  if (input.subscriptionStatus) params.subscription_status = input.subscriptionStatus;
  if (input.userType) params.user_type = input.userType;
  if (input.orderKind) params.order_kind = input.orderKind;
  if (input.fulfillmentStatus) params.fulfillment_status = input.fulfillmentStatus;
  if (input.autoRenewStatus) params.auto_renew_status = input.autoRenewStatus;
  if (input.alignmentStatus) params.alignment_status = input.alignmentStatus;
  if (input.membershipView) params.membership_view = input.membershipView;
  if (input.abnormalOnly) params.abnormal_only = true;
  return params;
}
